// Get all sites
export const GET_CLIENTS_REQUEST = "GET_CLIENTS_REQUEST";
export const GET_CLIENTS_SUCCESS = "GET_CLIENTS_SUCCESS";
export const GET_CLIENTS_FAILURE = "GET_CLIENTS_FAILURE";

// Add site
export const ADD_CLIENT_REQUEST = "ADD_CLIENT_REQUEST";
export const ADD_CLIENT_SUCCESS = "ADD_CLIENT_SUCCESS";
export const ADD_CLIENT_FAILURE = "ADD_CLIENT_FAILURE";

// Update site
export const UPDATE_CLIENT_REQUEST = "UPDATE_CLIENT_REQUEST";
export const UPDATE_CLIENT_SUCCESS = "UPDATE_CLIENT_SUCCESS";
export const UPDATE_CLIENT_FAILURE = "UPDATE_CLIENT_FAILURE";

// Delete site
export const DELETE_CLIENT_REQUEST = "DELETE_CLIENT_REQUEST";
export const DELETE_CLIENT_SUCCESS = "DELETE_CLIENT_SUCCESS";
export const DELETE_CLIENT_FAILURE = "DELETE_CLIENT_FAILURE";

// Get Site by Id
export const GET_CLIENT_BY_ID_REQUEST = "GET_CLIENT_BY_ID_REQUEST";
export const GET_CLIENT_BY_ID_SUCCESS = "GET_CLIENT_BY_ID_SUCCESS";
export const GET_CLIENT_BY_ID_FAILURE = "GET_CLIENT_TYPE_BY_ID_FAILURE";

// Delete Images
export const UPDATE_CLIENT_ENTITY_PARAMS_SUCCESS =
    "UPDATE_CLIENT_ENTITY_PARAMS_SUCCESS";
export const UPDATE_CLIENT_ENTITY_PARAMS_FAILURE =
    "UPDATE_CLIENT_ENTITY_PARAMS_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE";

export const GET_ALL_CLIENT_LOG_REQUEST = "GET_ALL_CLIENT_LOG_REQUEST";
export const GET_ALL_CLIENT_LOG_SUCCESS = "GET_ALL_CLIENT_LOG_SUCCESS";
export const GET_ALL_CLIENT_LOG_FAILURE = "GET_ALL_CLIENT_LOG_FAILURE";

export const RESTORE_CLIENT_LOG_REQUEST = "RESTORE_CLIENT_LOG_REQUEST";
export const RESTORE_CLIENT_LOG_SUCCESS = "RESTORE_CLIENT_LOG_SUCCESS";
export const RESTORE_CLIENT_LOG_FAILURE = "RESTORE_CLIENT_LOG_FAILURE";

export const DELETE_CLIENT_LOG_REQUEST = "DELETE_CLIENT_LOG_REQUEST";
export const DELETE_CLIENT_LOG_SUCCESS = "DELETE_CLIENT_LOG_SUCCESS";
export const DELETE_CLIENT_LOG_FAILURE = "DELETE_CLIENT_LOG_FAILURE";

export const GET_CLIENT_EXPORT_REQUEST = "GET_CLIENT_EXPORT_REQUEST";
export const GET_CLIENT_EXPORT_SUCCESS = "GET_CLIENT_EXPORT_SUCCESS";
export const GET_CLIENT_EXPORT_FAILURE = "GET_CLIENT_EXPORT_FAILURE";

export const GET_LANDING_PAGE_DATA_REQUEST = "GET_LANDING_PAGE_DATA_REQUEST";
export const GET_LANDING_PAGE_DATA_SUCCESS = "GET_LANDING_PAGE_DATA_SUCCESS";
export const GET_LANDING_PAGE_DATA_FAILURE = "GET_LANDING_PAGE_DATA_FAILURE";

export const UPDATE_LANDING_PAGE_DATA_REQUEST = "UPDATE_LANDING_PAGE_DATA_REQUEST";
export const UPDATE_LANDING_PAGE_DATA_SUCCESS = "UPDATE_LANDING_PAGE_DATA_SUCCESS";
export const UPDATE_LANDING_PAGE_DATA_FAILURE = "UPDATE_LANDING_PAGE_DATA_FAILURE";

export const ADD_LANDING_PAGE_DATA_REQUEST = "ADD_LANDING_PAGE_DATA_REQUEST";
export const ADD_LANDING_PAGE_DATA_SUCCESS = "ADD_LANDING_PAGE_DATA_SUCCESS";
export const ADD_LANDING_PAGE_DATA_FAILURE = "ADD_LANDING_PAGE_DATA_FAILURE";

export const COPY_CHART_TEMPLATE_REQUEST = "COPY_CHART_TEMPLATE_REQUEST";
export const COPY_CHART_TEMPLATE_SUCCESS = "COPY_CHART_TEMPLATE_SUCCESS";
export const COPY_CHART_TEMPLATE_FAILURE = "COPY_CHART_TEMPLATE_FAILURE";

export const GET_CLIENT_SETTINGS_REQUEST = "GET_CLIENT_SETTINGS_REQUEST";
export const GET_CLIENT_SETTINGS_SUCCESS = "GET_CLIENT_SETTINGS_SUCCESS";
export const GET_CLIENT_SETTINGS_FAILURE = "GET_CLIENT_SETTINGS_FAILURE";

export const UPDATE_CLIENT_SETTINGS_REQUEST = "UPDATE_CLIENT_SETTINGS_REQUEST";
export const UPDATE_CLIENT_SETTINGS_SUCCESS = "UPDATE_CLIENT_SETTINGS_SUCCESS";
export const UPDATE_CLIENT_SETTINGS_FAILURE = "UPDATE_CLIENT_SETTINGS_FAILURE";

export const GET_CLIENT_MISC_SETTINGS_REQUEST = "GET_CLIENT_MISC_SETTINGS_REQUEST";
export const GET_CLIENT_MISC_SETTINGS_SUCCESS = "GET_CLIENT_MISC_SETTINGS_SUCCESS";
export const GET_CLIENT_MISC_SETTINGS_FAILURE = "GET_CLIENT_MISC_SETTINGS_FAILURE";

export const UPDATE_CLIENT_MISC_SETTINGS_REQUEST = "UPDATE_CLIENT_MISC_SETTINGS_REQUEST";
export const UPDATE_CLIENT_MISC_SETTINGS_SUCCESS = "UPDATE_CLIENT_MISC_SETTINGS_SUCCESS";
export const UPDATE_CLIENT_MISC_SETTINGS_FAILURE = "UPDATE_CLIENT_MISC_SETTINGS_FAILURE";